import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem, Menu } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Student_Update_To_MongoDB_By_ID_And_Email_Confirmation } from "../../../api/Student_Update_To_MongoDB_By_ID_And_Email_Confirmation";
import { Link } from "react-router-dom";
import WEFChangePage from "../../../components/ChangePage/WEFChangePage";

function ViewPermissionsInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formPermissionsInfo, setformPermissionsInfo] = useState({
    Permissions_Parent_Filming: "",
    Permissions_Student_Filming: "",
    Permissions_Declare_Parent_Full_Name: "",
    Permissions_Declare_Parent_Relationship: "",
    Permissions_Declare_Parent_Signed: "",
    Permissions_Declare_Parent_Date: "",
    Permissions_Declare_Student_Full_Name: "",
    Permissions_Declare_Student_Signed: "",
    Permissions_Declare_Student_Date: "",
  });

  const [SEFProgress, setSEFProgress] = useState({
    PermissionsInfo: "",
  });
  const [FullContacts, setFullContacts] = useState([]);

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "SEFPermissionsInfo",
      setformPermissionsInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "Contacts",
      setFullContacts,
      logoutStudent
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformPermissionsInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFPermissionsInfo: formPermissionsInfo,
        "SEFProgress.PermissionsInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),

      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID_And_Email_Confirmation(
      {
        SEFPermissionsInfo: formPermissionsInfo,
        //SEFProgress: { PermissionsInfo: "Complete" },
        "SEFProgress.PermissionsInfo": "Complete",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),

      contacts,
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      PermissionsInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const isFormComplete =
    formPermissionsInfo &&
    formPermissionsInfo.Permissions_Parent_Filming &&
    formPermissionsInfo.Permissions_Student_Filming &&
    formPermissionsInfo.Permissions_Declare_Parent_Full_Name &&
    formPermissionsInfo.Permissions_Declare_Parent_Relationship &&
    formPermissionsInfo.Permissions_Declare_Parent_Signed &&
    formPermissionsInfo.Permissions_Declare_Parent_Date &&
    formPermissionsInfo.Permissions_Declare_Student_Full_Name &&
    formPermissionsInfo.Permissions_Declare_Student_Signed &&
    formPermissionsInfo.Permissions_Declare_Student_Date;

  let AttendeeEmail =
    FullContacts.find((contact) => contact.Person === "Attendee")?.Email || "";
  let ParentEmail =
    FullContacts.find((contact) => contact.Person === "Parent")?.Email || "";

  let contacts = [AttendeeEmail, ParentEmail];
  console.log("contacts", contacts);

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  return (
    <div className="view-basic-info-container">
      <h1>Declarations</h1>
      {SEFProgress &&
      SEFProgress.PermissionsInfo &&
      (SEFProgress.PermissionsInfo === "Complete" ||
        SEFProgress.PermissionsInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}

      <form className="view-basic-info-form">
        Across our programmes, InvestIN will capture video footage and take
        photographs for the use of media and promotional purposes. By law we are
        required to obtain informed parental consent to take pictures and video
        footage and use these for promotional purposes.
        <TextField
          label={removeUnderscores("Parent / legal guardian")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Parent_Filming"
          value={formPermissionsInfo?.Permissions_Parent_Filming}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes, I give my informed consent</MenuItem>
          <MenuItem value="No">No, I do not provide consent</MenuItem>
        </TextField>
        <TextField
          label={removeUnderscores("Student")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Student_Filming"
          value={formPermissionsInfo?.Permissions_Student_Filming}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes, I give my informed consent</MenuItem>
          <MenuItem value="No">No, I do not provide consent</MenuItem>
        </TextField>
        I, the Parent / Legal Guardian, declare that all information given is
        correct, and if any of the provided information changes I will inform
        InvestIN at my earliest convenience.
        <TextField
          label={removeUnderscores("Parent / legal guardian name")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Parent_Full_Name"
          value={formPermissionsInfo?.Permissions_Declare_Parent_Full_Name}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label={removeUnderscores("Relationship to the student")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Parent_Relationship"
          value={formPermissionsInfo?.Permissions_Declare_Parent_Relationship}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Mother">Mother</MenuItem>
          <MenuItem value="Father">Father</MenuItem>
          <MenuItem value="Legal Guardian">Legal Guardian</MenuItem>
        </TextField>
        <TextField
          label={removeUnderscores("Signature")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Parent_Signed"
          value={formPermissionsInfo?.Permissions_Declare_Parent_Signed}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label={removeUnderscores("Date")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Parent_Date"
          value={formPermissionsInfo?.Permissions_Declare_Parent_Date}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: formPermissionsInfo?.Permissions_Declare_Parent_Date
                ? "black"
                : "grey", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
          type="date"
        />
        I, the Student, declare that all information given is correct, and if
        any of the provided information changes I will inform InvestIN at my
        earliest convenience.
        <TextField
          label={removeUnderscores("Student name")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Student_Full_Name"
          value={formPermissionsInfo?.Permissions_Declare_Student_Full_Name}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label={removeUnderscores("Signature")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Student_Signed"
          value={formPermissionsInfo?.Permissions_Declare_Student_Signed}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label={removeUnderscores("Date")}
          variant="outlined"
          fullWidth
          required
          name="Permissions_Declare_Student_Date"
          value={formPermissionsInfo?.Permissions_Declare_Student_Date}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "right",
              color: formPermissionsInfo?.Permissions_Declare_Student_Date
                ? "black"
                : "grey", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
          type="date"
        />
        {/* END */}{" "}
        <WEFChangePage
          Page={"PermissionsInfo"}
          PageButtonStatus={PageButtonStatus}
        />
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.PermissionsInfo &&
                (SEFProgress.PermissionsInfo === "Complete" ||
                  SEFProgress.PermissionsInfo === "Awaiting_Review"))
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.PermissionsInfo &&
                (SEFProgress.PermissionsInfo === "Complete" ||
                  SEFProgress.PermissionsInfo === "Awaiting_Review"))
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewPermissionsInfo;
